import type { EventContentArg } from '@fullcalendar/core';
import type { KaliaEvent, KaliaResource } from './types';

export function buildEventContentArg(event: KaliaEvent, resources: KaliaResource[]): EventContentArg {
    const resourceMap = new Map(resources.map((r) => [r.id, r]));

    const mockEvent = {
        id: event.id,
        start: event.start,
        end: event.end,
        title: event.title,
        extendedProps: {
            metadata: event.metadata || {},
        },
        getResources: () =>
            event.resourceIds
                .map((rid) => resourceMap.get(rid))
                .filter(Boolean)
                .map((r) => ({ title: r!.title })),
    };

    return { event: mockEvent } as unknown as EventContentArg;
}
